import { axiosInstance } from "./axiosInstance";

// 1. 전체 1:1 문의 내역 조회
export const getAdminInquiries = async () => {
  try {
    const response = await axiosInstance.get(`/api/admin/cs/inquiries`);
    return response.data;
  } catch (error) {
    console.error("관리자 문의 내역 조회 실패:", error);
    throw error;
  }
};

// 2. 1:1 문의 답변 등록
export const answerInquiry = async (inquiryId: number, content: string) => {
  try {
    const response = await axiosInstance.post(`/api/admin/cs/inquiries/${inquiryId}/answer`, {
      content
    });
    return response.data;
  } catch (error) {
    console.error("관리자 답변 등록 실패:", error);
    throw error;
  }
};